"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get TableSystemColumns () {
        return TableSystemColumns;
    },
    get createHmAndBtColumn () {
        return createHmAndBtColumn;
    },
    get createOOColumn () {
        return createOOColumn;
    },
    get deleteColumnSystemPropsFromRequest () {
        return deleteColumnSystemPropsFromRequest;
    },
    get generateFkName () {
        return generateFkName;
    },
    get generateIndexNameForCustomLink () {
        return generateIndexNameForCustomLink;
    },
    get getMMColumnNames () {
        return getMMColumnNames;
    },
    get getRefColumnIfAlias () {
        return getRefColumnIfAlias;
    },
    get getRevType () {
        return getRevType;
    },
    get populateRollupForLTAR () {
        return populateRollupForLTAR;
    },
    get randomID () {
        return randomID;
    },
    get sanitizeColumnName () {
        return sanitizeColumnName;
    },
    get travelLookupColumn () {
        return travelLookupColumn;
    },
    get validateLookupPayload () {
        return validateLookupPayload;
    },
    get validateRequiredField () {
        return validateRequiredField;
    },
    get validateRollupPayload () {
        return validateRollupPayload;
    }
});
const _nanoid = require("nanoid");
const _nocodbsdk = require("nocodb-sdk");
const _inflection = require("inflection");
const _ncError = require("./ncError");
const _models = require("~/models");
const _validateParams = /*#__PURE__*/ _interop_require_default(require("~/helpers/validateParams"));
const _getUniqueName = require("~/helpers/getUniqueName");
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
const _ncconfig = require("~/utils/nc-config");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _constants = require("~/constants");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const randomID = (0, _nanoid.customAlphabet)('1234567890abcdefghijklmnopqrstuvwxyz_', 10);
async function createHmAndBtColumn(context, req, child, parent, childColumn, childView, type, alias, fkColName, virtual = false, isSystemCol = false, columnMeta = null, isLinks = false, colExtra, parentColumn, isCustom = false, columnWebhookManager) {
    let savedColumn;
    let crossBaseProps = {};
    // save bt column
    {
        const title = (0, _getUniqueName.getUniqueColumnAliasName)(await child.getColumns(_extends({}, context, {
            base_id: child.base_id
        })), type === 'bt' && alias || `${parent.title}`);
        // if parent and child are from different base then set cross base props
        if (parent.base_id !== child.base_id) {
            crossBaseProps = {
                fk_related_base_id: parent.base_id,
                fk_related_source_id: parent.id
            };
        }
        const childRelCol = await _Column.default.insert(_extends({}, context, {
            base_id: child.base_id
        }), _extends({
            title,
            fk_model_id: child.id,
            // ref_db_alias
            uidt: _nocodbsdk.UITypes.LinkToAnotherRecord,
            type: 'bt',
            // db_type:
            fk_child_column_id: childColumn.id,
            fk_parent_column_id: (parentColumn == null ? void 0 : parentColumn.id) || parent.primaryKey.id,
            fk_related_model_id: parent.id
        }, crossBaseProps, {
            virtual,
            readonly: (colExtra == null ? void 0 : colExtra.readonly) || false,
            // if self referencing treat it as system field to hide from ui
            system: isSystemCol || parent.id === child.id,
            fk_col_name: fkColName,
            fk_index_name: fkColName
        }, type === 'bt' ? colExtra : {}, {
            meta: _extends({}, (colExtra == null ? void 0 : colExtra.meta) || {}, {
                custom: isCustom
            })
        }));
        await (columnWebhookManager == null ? void 0 : columnWebhookManager.addNewColumnById({
            columnId: childRelCol.id,
            action: _nocodbsdk.WebhookActions.INSERT,
            context: _extends({}, context, {
                base_id: childRelCol.base_id
            })
        }));
        if (!isSystemCol) _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_CREATE, {
            table: child,
            column: childRelCol,
            columnId: childRelCol.id,
            req,
            context,
            columns: await child.getCachedColumns(context)
        });
    }
    // save hm column
    {
        const title = (0, _getUniqueName.getUniqueColumnAliasName)(await parent.getColumns(_extends({}, context, {
            base_id: parent.base_id
        })), type === 'hm' && alias || (0, _inflection.pluralize)(child.title));
        const meta = _extends({}, columnMeta || {}, {
            plural: (columnMeta == null ? void 0 : columnMeta.plural) || (0, _inflection.pluralize)(child.title),
            singular: (columnMeta == null ? void 0 : columnMeta.singular) || (0, _inflection.singularize)(child.title),
            custom: isCustom
        });
        // if parent and child are from different base then set cross base props
        if (parent.base_id !== child.base_id) {
            crossBaseProps = {
                fk_related_base_id: child.base_id,
                fk_related_source_id: child.id
            };
        }
        savedColumn = await _Column.default.insert(_extends({}, context, {
            base_id: parent.base_id
        }), _extends({
            title,
            fk_model_id: parent.id,
            uidt: isLinks ? _nocodbsdk.UITypes.Links : _nocodbsdk.UITypes.LinkToAnotherRecord,
            type: 'hm',
            fk_target_view_id: childView == null ? void 0 : childView.id,
            fk_child_column_id: childColumn.id,
            fk_parent_column_id: (parentColumn == null ? void 0 : parentColumn.id) || parent.primaryKey.id,
            fk_related_model_id: child.id,
            readonly: (colExtra == null ? void 0 : colExtra.readonly) || false,
            virtual,
            system: isSystemCol,
            fk_col_name: fkColName,
            fk_index_name: fkColName,
            meta
        }, type === 'hm' ? colExtra : {}, crossBaseProps));
        await (columnWebhookManager == null ? void 0 : columnWebhookManager.addNewColumnById({
            columnId: savedColumn.id,
            action: _nocodbsdk.WebhookActions.INSERT,
            context: _extends({}, context, {
                base_id: savedColumn.base_id
            })
        }));
        if (!isSystemCol) _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_CREATE, {
            table: parent,
            column: savedColumn,
            columnId: savedColumn.id,
            req: req,
            context,
            columns: await parent.getCachedColumns(context)
        });
    }
    return savedColumn;
}
async function createOOColumn(context, req, child, parent, childColumn, childView, type, alias, fkColName, virtual = false, isSystemCol = false, columnMeta = null, colExtra, parentColumn, isCustom = false, columnWebhookManager) {
    let savedColumn;
    const childContext = _extends({}, context, {
        base_id: child.base_id
    });
    const parentContext = _extends({}, context, {
        base_id: parent.base_id
    });
    let crossBaseProps = {};
    // save bt column
    {
        const title = (0, _getUniqueName.getUniqueColumnAliasName)(await child.getColumns(childContext), `${parent.title}`);
        // if parent and child are from different base then set cross base props
        if (parent.base_id !== child.base_id) {
            crossBaseProps = {
                fk_related_base_id: parent.base_id,
                fk_related_source_id: parent.id
            };
        }
        const childRelCol = await _Column.default.insert(childContext, _extends({
            title,
            fk_model_id: child.id,
            // ref_db_alias
            uidt: _nocodbsdk.UITypes.LinkToAnotherRecord,
            type: _nocodbsdk.RelationTypes.ONE_TO_ONE,
            // Child View ID is given for relation from parent to child. not for child to parent
            fk_target_view_id: null,
            fk_child_column_id: childColumn.id,
            fk_parent_column_id: (parentColumn == null ? void 0 : parentColumn.id) || parent.primaryKey.id,
            fk_related_model_id: parent.id,
            virtual,
            readonly: (colExtra == null ? void 0 : colExtra.readonly) || false,
            // if self referencing treat it as system field to hide from ui
            system: isSystemCol || parent.id === child.id,
            fk_col_name: fkColName,
            fk_index_name: fkColName,
            // ...(colExtra || {}),
            meta: _extends({}, (colExtra == null ? void 0 : colExtra.meta) || {}, {
                // one-to-one relation is combination of both hm and bt to identify table which have
                // foreign key column(similar to bt) we are adding a boolean flag `bt` under meta
                bt: true,
                custom: isCustom
            })
        }, crossBaseProps));
        await (columnWebhookManager == null ? void 0 : columnWebhookManager.addNewColumnById({
            columnId: childRelCol.id,
            action: _nocodbsdk.WebhookActions.INSERT,
            context: _extends({}, context, {
                base_id: childRelCol.base_id
            })
        }));
        _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_CREATE, {
            table: child,
            column: childRelCol,
            columnId: childRelCol.id,
            req,
            context: childContext,
            columns: await child.getCachedColumns(childContext)
        });
    }
    // save hm column
    {
        const title = (0, _getUniqueName.getUniqueColumnAliasName)(await parent.getColumns(parentContext), alias || child.title);
        // if parent and child are from different base then set cross base props
        if (parent.base_id !== child.base_id) {
            crossBaseProps = {
                fk_related_base_id: child.base_id,
                fk_related_source_id: child.id
            };
        }
        // remove bt flag from meta as it have to be on child column
        if (columnMeta == null ? void 0 : columnMeta.bt) {
            delete columnMeta.bt;
        }
        const meta = _extends({}, columnMeta || {}, {
            plural: (columnMeta == null ? void 0 : columnMeta.plural) || (0, _inflection.pluralize)(child.title),
            singular: (columnMeta == null ? void 0 : columnMeta.singular) || (0, _inflection.singularize)(child.title),
            custom: isCustom
        });
        savedColumn = await _Column.default.insert(parentContext, _extends({
            title,
            fk_model_id: parent.id,
            uidt: _nocodbsdk.UITypes.LinkToAnotherRecord,
            type: 'oo',
            fk_target_view_id: childView == null ? void 0 : childView.id,
            fk_child_column_id: childColumn.id,
            fk_parent_column_id: (parentColumn == null ? void 0 : parentColumn.id) || parent.primaryKey.id,
            fk_related_model_id: child.id,
            virtual,
            system: isSystemCol,
            fk_col_name: fkColName,
            fk_index_name: fkColName,
            meta,
            readonly: (colExtra == null ? void 0 : colExtra.readonly) || false
        }, crossBaseProps, colExtra || {}));
        await (columnWebhookManager == null ? void 0 : columnWebhookManager.addNewColumnById({
            columnId: savedColumn.id,
            action: _nocodbsdk.WebhookActions.INSERT,
            context: _extends({}, context, {
                base_id: savedColumn.base_id
            })
        }));
        _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.COLUMN_CREATE, {
            table: parent,
            column: savedColumn,
            columnId: savedColumn.id,
            req,
            context: parentContext,
            columns: await parent.getCachedColumns(parentContext)
        });
    }
    return savedColumn;
}
async function validateRollupPayload(context, payload) {
    (0, _validateParams.default)([
        'title',
        'fk_relation_column_id',
        'fk_rollup_column_id',
        'rollup_function'
    ], payload, context);
    const column = await _Column.default.get(context, {
        colId: payload.fk_relation_column_id
    });
    const relation = await column.getColOptions(context);
    const { refContext } = relation.getRelContext(context);
    if (!relation) {
        _ncError.NcError.get(context).relationFieldNotFound(payload.fk_relation_column_id);
    }
    let relatedColumn;
    const relationType = (0, _nocodbsdk.isMMOrMMLike)(column) ? 'mm' : relation.type;
    switch(relationType){
        case 'hm':
            relatedColumn = await _Column.default.get(refContext, {
                colId: relation.fk_child_column_id
            });
            break;
        case 'mm':
        case 'bt':
            relatedColumn = await _Column.default.get(refContext, {
                colId: relation.fk_parent_column_id
            });
            break;
    }
    const relatedTable = await relatedColumn.getModel(refContext);
    const rollupColumn = (await relatedTable.getColumns(refContext)).find((c)=>c.id === payload.fk_rollup_column_id);
    if (!rollupColumn) _ncError.NcError.get(context).badRequest('Rollup column not found in related table');
    if (!(0, _nocodbsdk.getAvailableRollupForUiType)(rollupColumn.uidt).includes(payload.rollup_function)) {
        _ncError.NcError.get(context).badRequest(`Rollup function (${payload.rollup_function}) not available for type (${relatedColumn.uidt})`);
    }
}
async function validateLookupPayload(context, payload, columnId) {
    (0, _validateParams.default)([
        'title',
        'fk_relation_column_id',
        'fk_lookup_column_id'
    ], payload, context);
    const column = await _Column.default.get(context, {
        colId: payload.fk_relation_column_id
    });
    if (!column) {
        _ncError.NcError.get(context).relationFieldNotFound(payload.fk_relation_column_id);
    }
    const relation = await column.getColOptions(context);
    const { refContext } = relation.getRelContext(context);
    // check for circular reference (must be done after getting refContext for cross-base)
    if (columnId) {
        let lkCol = payload;
        while(lkCol){
            // check if lookup column is same as column itself
            if (columnId === lkCol.fk_lookup_column_id) _ncError.NcError.get(context).badRequest('Circular lookup reference not allowed');
            lkCol = await _Column.default.get(refContext, {
                colId: lkCol.fk_lookup_column_id
            }).then((c)=>{
                if (c && c.uidt === 'Lookup') {
                    return c.getColOptions(refContext);
                }
                return null;
            });
        }
    }
    if (!relation) {
        _ncError.NcError.get(context).relationFieldNotFound(payload.fk_relation_column_id);
    }
    let relatedColumn;
    const relationType = (0, _nocodbsdk.isMMOrMMLike)(column) ? 'mm' : relation.type;
    switch(relationType){
        case 'hm':
            relatedColumn = await _Column.default.get(refContext, {
                colId: relation.fk_child_column_id
            });
            break;
        case 'mm':
        case 'bt':
            relatedColumn = await _Column.default.get(refContext, {
                colId: relation.fk_parent_column_id
            });
            break;
        case 'oo':
            var _column_meta;
            relatedColumn = await _Column.default.get(refContext, {
                colId: ((_column_meta = column.meta) == null ? void 0 : _column_meta.bt) ? relation.fk_parent_column_id : relation.fk_child_column_id
            });
            break;
    }
    const relatedTable = await relatedColumn.getModel(refContext);
    if (!(await relatedTable.getColumns(refContext)).find((c)=>c.id === payload.fk_lookup_column_id)) _ncError.NcError.get(context).badRequest('Lookup column not found in related table');
}
const validateRequiredField = (payload, requiredProps)=>{
    return requiredProps.every((prop)=>prop in payload && payload[prop] !== undefined && payload[prop] !== null);
};
const generateFkName = (parent, child)=>{
    // generate a unique constraint name by taking first 10 chars of parent and child table name (by replacing all non word chars with _)
    // and appending a random string of 15 chars maximum length.
    // In database constraint name can be upto 64 chars and here we are generating a name of maximum 40 chars
    const constraintName = `fk_${parent.table_name.replace(/\W+/g, '_').slice(0, 10)}_${child.table_name.replace(/\W+/g, '_').slice(0, 10)}_${randomID()}`;
    return constraintName;
};
const generateIndexNameForCustomLink = (tableTitle, columnName)=>{
    // sanitize and shorten tableTitle and columnName (max 10 chars each)
    const sanitizedTable = tableTitle.replace(/\W+/g, '_').slice(0, 10);
    const sanitizedColumn = columnName.replace(/\W+/g, '_').slice(0, 10);
    // max length 40 chars, prefix with "idx_" to indicate index name
    const indexName = `idx_${sanitizedTable}_${sanitizedColumn}_${randomID()}`;
    return indexName;
};
async function populateRollupForLTAR({ context, column, columnMeta, alias }) {
    var _relatedModel_primaryKey, _;
    const model = await column.getModel(context);
    const views = await model.getViews(context);
    const relatedModel = await column.getColOptions(context).then((colOpt)=>colOpt.getRelatedTable(context));
    await relatedModel.getColumns(context);
    const pkId = ((_relatedModel_primaryKey = relatedModel.primaryKey) == null ? void 0 : _relatedModel_primaryKey.id) || ((_ = (await relatedModel.getColumns(context))[0]) == null ? void 0 : _.id);
    const meta = {
        plural: (columnMeta == null ? void 0 : columnMeta.plural) || (0, _inflection.pluralize)(relatedModel.title),
        singular: (columnMeta == null ? void 0 : columnMeta.singular) || (0, _inflection.singularize)(relatedModel.title)
    };
    await _Column.default.insert(context, {
        uidt: _nocodbsdk.UITypes.Links,
        title: (0, _getUniqueName.getUniqueColumnAliasName)(await model.getColumns(context), alias || `${relatedModel.title} Count`),
        fk_rollup_column_id: pkId,
        fk_model_id: model.id,
        rollup_function: 'count',
        fk_relation_column_id: column.id,
        meta
    });
    const viewCol = await _models.GridViewColumn.list(context, views[0].id).then((cols)=>cols.find((c)=>c.fk_column_id === column.id));
    await _models.GridViewColumn.update(context, viewCol.id, {
        show: false
    });
}
const sanitizeColumnName = (name, sourceType)=>{
    if (process.env.NC_SANITIZE_COLUMN_NAME === 'false') return name;
    let columnName = name.replace(new RegExp(`[^${_nocodbsdk.REGEXSTR_INTL_LETTER}${_nocodbsdk.REGEXSTR_NUMERIC_ARABIC}_]`, 'g'), '_');
    // if column name only contains _ then return as 'field'
    if (/^_+$/.test(columnName)) columnName = 'field';
    if (sourceType) {
        if (sourceType === _ncconfig.DriverClient.DATABRICKS) {
            // databricks column name should be lowercase
            columnName = columnName.toLowerCase();
        }
    }
    return columnName;
};
const getRefColumnIfAlias = async (context, column, columns)=>{
    if (!column) return null;
    if (![
        _nocodbsdk.UITypes.CreatedTime,
        _nocodbsdk.UITypes.LastModifiedTime,
        _nocodbsdk.UITypes.CreatedBy,
        _nocodbsdk.UITypes.LastModifiedBy
    ].includes(column.uidt)) return column;
    return (columns || await _Column.default.list(context, {
        fk_model_id: column.fk_model_id
    })).find((c)=>c.system && c.uidt === column.uidt) || column;
};
const travelLookupColumn = async ({ context, column })=>{
    const lookupColOptions = await column.getColOptions(context);
    const targetColumn = await _Column.default.get(context, {
        colId: lookupColOptions.fk_lookup_column_id
    });
    if (targetColumn.uidt === _nocodbsdk.UITypes.Lookup) {
        return travelLookupColumn({
            context,
            column: targetColumn
        });
    } else {
        return targetColumn;
    }
};
const getMMColumnNames = (parent, child)=>{
    const parentCn = `${parent.table_name.slice(0, 30)}_id`;
    let childCn = `${child.table_name.slice(0, 30)}_id`;
    // handle duplicate column names in self referencing tables or if first 30 characters are same
    if (parentCn === childCn) {
        childCn = `${child.table_name.slice(0, 29)}1_id`;
    }
    return {
        parentCn,
        childCn
    };
};
const TableSystemColumns = (isMetaColSupport = false)=>[
        {
            column_name: 'id',
            title: 'Id',
            uidt: _nocodbsdk.UITypes.ID,
            allowNonSystem: false,
            system: false
        },
        {
            column_name: 'created_at',
            title: 'CreatedAt',
            uidt: _nocodbsdk.UITypes.CreatedTime,
            allowNonSystem: true,
            system: true
        },
        {
            column_name: 'updated_at',
            title: 'UpdatedAt',
            uidt: _nocodbsdk.UITypes.LastModifiedTime,
            allowNonSystem: true,
            system: true
        },
        {
            column_name: 'created_by',
            title: 'nc_created_by',
            uidt: _nocodbsdk.UITypes.CreatedBy,
            allowNonSystem: true,
            system: true
        },
        {
            column_name: 'updated_by',
            title: 'nc_updated_by',
            uidt: _nocodbsdk.UITypes.LastModifiedBy,
            allowNonSystem: true,
            system: true
        },
        {
            column_name: 'nc_order',
            title: 'nc_order',
            uidt: _nocodbsdk.UITypes.Order,
            allowNonSystem: false,
            system: true
        },
        ...isMetaColSupport ? [
            {
                column_name: _constants.META_COL_NAME,
                title: _constants.META_COL_NAME,
                uidt: _nocodbsdk.UITypes.Meta,
                allowNonSystem: false,
                system: true
            }
        ] : []
    ];
const deleteColumnSystemPropsFromRequest = (col)=>{
    // remove all properties not in documentations
    delete col.dt;
    delete col.np;
    delete col.ns;
    delete col.clen;
    delete col.cop;
    delete col.pk;
    delete col.rqd;
    delete col.un;
    delete col.ai;
    delete col.cc;
    delete col.csn;
    delete col.dtx;
    // dtxs is scale, used in decimal uidt
    // delete col.dtxs;
    delete col.au;
    delete col.validate;
    delete col.system;
};
const getRevType = (type)=>{
    switch(type){
        case _nocodbsdk.RelationTypes.BELONGS_TO:
            return _nocodbsdk.RelationTypes.HAS_MANY;
        case _nocodbsdk.RelationTypes.HAS_MANY:
            return _nocodbsdk.RelationTypes.BELONGS_TO;
        case _nocodbsdk.RelationTypes.MANY_TO_ONE:
            return _nocodbsdk.RelationTypes.ONE_TO_MANY;
        case _nocodbsdk.RelationTypes.ONE_TO_MANY:
            return _nocodbsdk.RelationTypes.MANY_TO_ONE;
    }
    return type;
};
